/*
 * @Description: 案例审核右侧表单
 * @Author: hanpengtao
 * @Date: 2022-04-26 15:12:01
 */
import React, { useEffect, useState, useRef } from 'react';
import { Select, Input, DatePicker, Button, message, Switch, Radio } from 'antd';
import { useSetState } from 'ahooks';
import moment from 'moment';
import ClassifyCascader from '@/component/ClassifyCascader/index';
import SelectWithTags from '@/component/SelectWithTags/index';
import ExaminationFailedReasonModal from '../ExaminationFailedReasonModal/index';
import './index.less';

const { Option } = Select;

const caseLevel = [
  {
    id: 1,
    name: '一级',
  },
  {
    id: 2,
    name: '二级',
  },
  {
    id: 3,
    name: '三级',
  },
  {
    id: 4,
    name: '四级',
  },
  {
    id: 5,
    name: '五级',
  },
  {
    id: 6,
    name: '六级',
  }
];
const Sourse = ['自营爬取', '用户上传', '运营导入'];
const CopyRight = ['原创作品', '分享采集'];

const getInitParams = () => ({
  titleOrigin: '', // 标题
  classifyId: null,  // 分类id
  caseLevel: undefined,  // 等级
  publishTime: null, // 案例发布时间
  styleList: [], // 风格
  designList: [], // 设计师
  colorList: [], // 颜色
  materialList: [], // 材质
  // countryRegion: undefined, // 国家地区
  country: undefined, // 入库国家 
  awardList: [], // 奖项
  developert: undefined, // 开发商
  featureList: [], // 特征
  theme: undefined, // 主题
  people: undefined, // 适用人群
  brand: undefined, // 品牌
  caseImgType: null,// 案例图片类型
})

const FormInfo = (props) => {
  const { caseData, propertyInfo, currentMode, getPropertyList, handleSubmit, onChange, submitLoading, examineMode, setVisible,
    handleQuery, handleNext } = props;
  const { awardList, brandList, colorList, countryList, designList, developertList, featureList, materialList, nationCountryList, peopleList, styleList, themeList, addDesignNameList } = propertyInfo || {};

  const [formValue, setFormValue] = useSetState(getInitParams());

  const [examinationFailedVisible, setExaminationFailedVisible] = useState(false); // 控制审核失败原因弹框

  const [isOffshelf, setIsOffshelf] = useState(false);

  const [changed, setChanged] = useState(false);

  const wrapperRef = useRef(null);

  useEffect(() => {
    // 回显表单数据
    setFormValue({
      titleOrigin: caseData?.caseInfo?.titleOrigin?.trim?.(),
      titleTranslated: caseData?.caseInfo?.titleTranslated?.trim?.(),
      classifyId: caseData?.caseClassifyDtos?.[0]?.id,
      caseLevel: caseData?.caseLevel?.caseLevel,
      publishTime: moment(caseData?.caseInfo?.publishTime),
      styleList: caseData?.styleList?.map(item => item.id) ?? [],
      designList: caseData?.designList?.map(item => item.id) ?? [],
      colorList: caseData?.colorList?.map(item => item.id) ?? [],
      materialList: caseData?.materialList?.map(item => item.id) ?? [],
      // countryRegion: caseData?.countryList?.[0]?.id,
      country: caseData?.caseInfo?.country || undefined,
      awardList: caseData?.awardList?.map(item => item.id) ?? [],
      developert: caseData?.developertList?.[0]?.id,
      featureList: caseData?.featureList?.map(item => item.id) ?? [],
      theme: caseData?.themeList?.[0]?.id,
      people: caseData?.peopleList?.[0]?.id,
      brand: caseData?.brandList?.[0]?.id,
      caseImgType: caseData?.caseInfo?.caseImgType ?? 0,
    });
  }, [caseData]);
  useEffect(() => {
    onChange(formValue);
  }, [formValue]);
  // 审核未通过
  const examinationFailed = () => {
    setExaminationFailedVisible(true);
    setIsOffshelf(false)
  }
  // 下架逻辑
  const examinationFailedOffshelf = () => {
    setExaminationFailedVisible(true);
    setIsOffshelf(true)
  }
  // 获取下一个案例id的交互
  const proHandleNext = () => {
    handleNext();
    setChanged(pre => !pre);
  }
  return (
    <div className='formInfo'>
      <div className='wrapper' ref={wrapperRef}>
        <div className='formItem_copyRight'>
          <span>来源：{Sourse[caseData?.caseInfo?.sourceType]}</span>
          {
            caseData?.caseInfo?.sourceType == 1 ? <span>版权：{CopyRight[caseData?.versionNo - 1]}</span> : null
          }
        </div>
        <div className='formItem' style={{ display: 'flex', flexDirection: 'row' }}>
          <span>标题：</span>
          <Input.TextArea
            style={{ width: 240 }}
            placeholder="请输入"
            value={formValue.titleOrigin}
            onChange={(e) => setFormValue({ titleOrigin: e.target.value })}
          />
        </div>
        {
          formValue.titleTranslated ? <div className='formItem' style={{ display: 'flex', flexDirection: 'row' }}>
            <span>中文标题：</span>
            <div>
              {formValue.titleTranslated}
            </div>
          </div> : null
        }

        <div className='formItem'>
          <ClassifyCascader
            getPopupContainer={() => wrapperRef.current}
            value={formValue.classifyId}
            onChange={(classifyId) => {
              setFormValue({ classifyId });
              // 开发商，特征，主题，适用人群，品牌下拉选项需要根据分类获取
              getPropertyList(classifyId ?? 0);
              setFormValue({
                developert: undefined,
                featureList: [],
                theme: undefined,
                people: undefined,
                brand: undefined,
              });
            }}
          />
        </div>

        <div className='formItem'>
          <span>等级：</span>
          <Select
            style={{ width: 240 }}
            placeholder='请选择'
            getPopupContainer={() => wrapperRef.current}
            value={formValue.caseLevel}
            onChange={(caseLevel) => setFormValue({ caseLevel })}
          >
            {
              caseLevel.map((item) => (
                <Option value={item.id} key={item.id}>{item.name}</Option>
              ))
            }
          </Select>
        </div>

        <div className='formItem'>
          <span>发布时间：</span>
          <DatePicker
            showTime
            getCalendarContainer={() => wrapperRef.current}
            value={formValue.publishTime}
            onChange={(publishTime) => setFormValue({ publishTime })}
          />
        </div>
        {/* <div className='common'>共有属性</div> */}

        <div className='formItem'>
          <SelectWithTags
            label='风格'
            style={{ width: 240 }}
            getPopupContainer={() => wrapperRef.current}
            sourceList={styleList}
            value={formValue.styleList}
            onChange={(styleList) => { setFormValue({ styleList }) }}
          />
        </div>

        <div className='formItem'>
          <SelectWithTags
            isVirtual
            hasChange={changed}
            label='设计师'
            style={{ width: 220 }}
            getPopupContainer={() => wrapperRef.current}
            sourceList={designList}
            value={formValue.designList}
            onChange={(selectValue)=>{
              setFormValue({designList:selectValue})
            }}
          />
          <div className='selectWithTags'>

          </div>
        </div>

        {/* <div className='formItem'>
          <SelectWithTags
            label='颜色'
            style={{ width: 240 }}
            getPopupContainer={() => wrapperRef.current}
            sourceList={colorList}
            value={formValue.colorList}
            onChange={(colorList) => setFormValue({ colorList })}
          />
        </div> */}

        {/* <div className='formItem'>
          <SelectWithTags
            label='材质'
            style={{ width: 240 }}
            getPopupContainer={() => wrapperRef.current}
            sourceList={materialList}
            value={formValue.materialList}
            onChange={(materialList) => setFormValue({ materialList })}
          />
        </div> */}

        {/* <div className='formItem'>
          <span>国家地区：</span>
          <Select
            style={{ width: 240 }}
            getPopupContainer={() => wrapperRef.current}
            placeholder='请选择'
            allowClear
            showArrow
            showSearch
            optionFilterProp="children"
            value={formValue.countryRegion}
            onChange={(countryRegion) => setFormValue({ countryRegion })}
          >
            {
              countryList?.map((item) => (
                <Option value={item.id} key={item.id}>{item.name}</Option>
              ))
            }
          </Select>
        </div> */}

        <div className='formItem'>
          <span>入库国家：</span>
          <Select
            style={{ width: 240 }}
            getPopupContainer={() => wrapperRef.current}
            placeholder='请选择'
            allowClear
            showArrow
            showSearch
            optionFilterProp="children"
            value={formValue.country}
            onChange={(country) => setFormValue({ country })}
          >
            {
              nationCountryList?.map((item) => (
                <Option value={item.name} key={item.id}>{item.name}</Option>
              ))
            }
          </Select>
        </div>

        <div className='formItem'>
          <SelectWithTags
            label='奖项'
            style={{ width: 240 }}
            getPopupContainer={() => wrapperRef.current}
            sourceList={awardList}
            value={formValue.awardList}
            onChange={(awardList) => setFormValue({ awardList })}
          />
        </div>
        <div className='formItem'>
          <Radio.Group
            value={formValue.caseImgType}
            getPopupContainer={() => wrapperRef.current}
            onChange={(e) => setFormValue({ caseImgType: e.target.value })}
            defaultValue={formValue.caseImgType}
          >
            <Radio.Button value={0}>实景图</Radio.Button>
            <Radio.Button value={1}>效果图</Radio.Button>
          </Radio.Group>
        </div>
        {developertList?.length ? (
          <div className='formItem'>
            <span>开发商：</span>
            <Select
              style={{ width: 240 }}
              getPopupContainer={() => wrapperRef.current}
              placeholder='请选择'
              allowClear
              showArrow
              showSearch
              optionFilterProp="children"
              value={formValue.developert}
              onChange={(developert) => setFormValue({ developert })}
            >
              {
                developertList?.map((item) => (
                  <Option value={item.id} key={item.id}>{item.name}</Option>
                ))
              }
            </Select>
          </div>
        ) : null}

        {featureList?.length ? (
          <div className='formItem'>
            <SelectWithTags
              label='特征'
              style={{ width: 240 }}
              getPopupContainer={() => wrapperRef.current}
              sourceList={featureList}
              value={formValue.featureList}
              onChange={(featureList) => setFormValue({ featureList })}
            />
          </div>
        ) : null}

        {themeList?.length ? (
          <div className='formItem'>
            <span>主题：</span>
            <Select
              style={{ width: 240 }}
              getPopupContainer={() => wrapperRef.current}
              placeholder='请选择'
              allowClear
              showArrow
              showSearch
              optionFilterProp="children"
              value={formValue.theme}
              onChange={(theme) => setFormValue({ theme })}
            >
              {
                themeList?.map((item) => (
                  <Option value={item.id} key={item.id}>{item.name}</Option>
                ))
              }
            </Select>
          </div>
        ) : null}

        {peopleList?.length ? (
          <div className='formItem'>
            <span>适用人群：</span>
            <Select
              style={{ width: 240 }}
              getPopupContainer={() => wrapperRef.current}
              placeholder='请选择'
              allowClear
              showArrow
              showSearch
              optionFilterProp="children"
              value={formValue.people}
              onChange={(people) => setFormValue({ people })}
            >
              {
                peopleList?.map((item) => (
                  <Option value={item.id} key={item.id}>{item.name}</Option>
                ))
              }
            </Select>
          </div>
        ) : null}

        {brandList?.length ? (
          <div className='formItem'>
            <span>品牌：</span>
            <Select
              style={{ width: 240 }}
              getPopupContainer={() => wrapperRef.current}
              placeholder='请选择'
              allowClear
              showArrow
              showSearch
              optionFilterProp="children"
              value={formValue.brand}
              onChange={(brand) => setFormValue({ brand })}
            >
              {
                brandList?.map((item) => (
                  <Option value={item.id} key={item.id}>{item.name}</Option>
                ))
              }
            </Select>
          </div>
        ) : null}
        {
          caseData?.caseExtend && <>
            <div className='formItem'>
              <span>位置：{caseData?.caseExtend?.address}</span>
            </div>
            <div className='formItem'>
              <span>年份：{caseData?.caseExtend?.year}</span>
            </div>
            <div className='formItem'>
              <span>面积：{caseData?.caseExtend?.area}</span>
            </div>
            <div className='formItem'>
              <span>材料：{caseData?.caseExtend?.material}</span>
            </div>
          </>
        }

        <div className='center'>
          {
            examineMode ? <><Button
              style={{ marginRight: 10 }}
              type='danger'
              loading={submitLoading}
              onClick={() => {
                examinationFailed()
              }}
            >
              审核不通过
            </Button>
              <Button
                type='primary'
                loading={submitLoading}
                onClick={() => {
                  if (!formValue.titleOrigin.trim()) {
                    message.info('请输入标题');
                    return;
                  }

                  handleSubmit({
                    isReview: true,
                    currentMode,
                    setChanged
                  })
                }}
              >
                保存并审核通过
              </Button>
              <Button
                style={{ marginLeft: 10 }}
                type='danger'
                loading={submitLoading}
                onClick={() => {
                  examinationFailedOffshelf()
                }}
              >
                下架
              </Button>
            </> :
              <>
                <Button
                  className='submitBtn'
                  type='primary'
                  loading={submitLoading}
                  onClick={() => {
                    if (!formValue.titleOrigin.trim()) {
                      message.info('请输入标题');
                      return;
                    }
                    handleSubmit({
                      isReview: true,
                      setChanged,
                    })
                  }}
                >
                  确认修改
                </Button>
                <Button
                  style={{ marginLeft: 10 }}
                  type='danger'
                  loading={submitLoading}
                  onClick={() => {
                    examinationFailedOffshelf()
                  }}
                >
                  下架
                </Button>
              </>
          }
        </div>
      </div>
      <ExaminationFailedReasonModal handleNext={proHandleNext} examinationFailedVisible={examinationFailedVisible} setExaminationFailedVisible={setExaminationFailedVisible} offShelf={isOffshelf} caseId={caseData?.caseInfo?.caseId} setVisible={setVisible} handleQuery={handleQuery} />
    </div>
  )
}

export default FormInfo;